import { render, staticRenderFns } from "./SwapInput.vue?vue&type=template&id=6d3cf8ff&scoped=true&"
import script from "./SwapInput.vue?vue&type=script&lang=ts&"
export * from "./SwapInput.vue?vue&type=script&lang=ts&"
import style0 from "./SwapInput.vue?vue&type=style&index=0&id=6d3cf8ff&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cf8ff",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QBadge,QIcon,QBanner});
